<div class="checkbox-category">
  <label class="custom-checkbox-container">
    <input type="checkbox" class="checkbox" [(ngModel)]="hasNoCategory" (change)="onChangesCategoryEnable()" name="hasCategory">
    <span class="checkmark"></span>
  </label>
  <label class="label-text" translate>T_ODM_OPTION_NO_CATEGORY</label>
</div>

<div *ngIf="showCategory()" class="category-name" >
  <div class="category-name-id">
    <span class="category-name-id-label" >id :</span>
    <p-autoComplete class="category-name-selection"
                    [(ngModel)]="currentCategory"
                    scrollHeight="120px"
                    [suggestions]="filteredCategories"
                    (completeMethod)="filterCategoryReference($event)"
                    [emptyMessage]="'T_OFFER_DATA_MANAGEMENT_NO_CATEGORY_FOUND' | translate"
                    (ngModelChange)="onChangesCategoryField($event);"
                    [dropdown]="true"
                    dropdownMode="blank">
    </p-autoComplete>
  </div>

  <div *ngFor="let item of categoryValueForm.value | keyvalue; trackBy: trackByFn" class="edit-category-name">
    <span class="edit-category-name-label" >{{item.key}}:</span>
    <input [(ngModel)]="categoryValueForm.value[item.key]" (change)="onChangesCategoryField(this.currentCategory)" class="edit-category-name-input" type="text" />
  </div>
</div>
